import type { DataType } from "@repo/lanes";

import type { OperationType } from "../operation-types";

/**
 * Returns the default aggregation operation for a column type when GROUP BY is
 * active and the user has not configured an explicit aggregate.
 *
 * Design decisions:
 *   NUMBER  → SUM        — most analytically useful for metrics.
 *   BOOLEAN → COUNT_TRUE — surfaces a meaningful count rather than an arbitrary value.
 *   ARRAY   → COUNT_VALUE — counts non-null items; arrays cannot be SUM'd or MIN'd reliably.
 *   OBJECT  → COUNT_VALUE — same reasoning as ARRAY.
 *   DATE    → MAX — surfaces the most recent date, which is typically the most relevant.
 *   STRING  → COUNT — a per-group row count is a usable measure that charts can
 *             plot; concatenating every value produced unreadable cells instead.
 *
 * STRING is also the fallback for a type the platform does not recognize.
 */
export const defaultAggForType = (type: DataType): OperationType => {
  switch (type) {
    case "NUMBER":
      return "SUM";
    case "BOOLEAN":
      return "COUNT_TRUE";
    case "DATE":
      return "MAX";
    case "ARRAY":
    case "OBJECT":
      return "COUNT_VALUE";
    default:
      return "COUNT";
  }
};
